<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <button type="button" class="btn btn-link" data-toggle="button" aria-pressed="true" (click)="scrollToTop()">
    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#chevron-up">
    </svg>
  </button>
</div>
